<template>
  <custom-dialog width="1280px" :title="model.title" :visible="visible" v-on="$listeners" class="protocol-model-import-dialog">
    <div class="dialog-body">
      <custom-tab v-model="showTab" :list="tabList" @change="onTableChange()"></custom-tab>
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent label-width="auto">
          <el-form-item v-if="showTab === '2'">
            <el-button :disabled="!selectOut.length" @click="removeSelect">
              <i class="icon icon-shanchu"></i>
              <span>&ensp;{{ $t('dms_step_model_import_dialog.pi_liang_shan_chu') }}</span>
            </el-button>
          </el-form-item>
          <el-form-item :label="$t('dms_step_model_import_dialog.xie_yi')" v-if="showTab === '1'">
            <el-select v-model="formSearch.fromProtocolCode" @change="onPageChange({ page: 1 })" :clearable="false">
              <el-option v-for="(item, index) in deviceType" :key="index" :label="item.protocolCode" :value="item.protocolName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right" v-if="showTab === '1'">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_step_model_import_dialog.wmxmcwmxdm')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right" v-if="showTab === '1'">
            <switch-button ref="containerBtn" :link="$refs.container"></switch-button>
          </el-form-item>
          <el-form-item style="float: right" v-if="showTab === '1'">
            <el-radio-group v-model="formSearch.tslClass" @change="changeTslClass()">
              <el-radio-button v-for="(item, index) in propertyMap.iot_tsl_class_type" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_step_model_import_dialog.lei_xing')">
            <el-select clearable v-model="formSearch.tslType">
              <el-option v-for="(item, i) in tslTypeList" :key="i" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <!-- <custom-select v-model="formSearch.tslType" code="iot_tsl_type"></custom-select> -->
          </el-form-item>
          <el-form-item :label="$t('dms_step_model_import_dialog.bu_jian')">
            <el-input v-model="formSearch.component"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_step_model_import_dialog.fen_lei')">
            <el-input v-model="formSearch.dataGroup"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_step_model_import_dialog.TCPdai_ma')">
            <el-input v-model="formSearch.tcpDataCode"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd" v-if="showTab === '1'">
        <custom-table key="1" v-model="selectIn" type="checkbox" tableCode="protocol_model_import" :data="tableList" @sort="sortChange" @filter="filterChange" :slots="['showUnit', 'needTestTypes']">
          <!-- 显示单位 showRatio showUnit iot_tsl_data_unit -->
          <template v-slot:showUnit="scope">
            {{ getShowUnit(scope.row) }}
          </template>
          <template v-slot:needTestTypes="scope">
            {{ getNeedTestTypes(scope.row.needTestTypes) || '-' }}
          </template>
        </custom-table>
      </div>
      <div class="table-bd" v-if="showTab === '2'">
        <custom-table
          key="2"
          :isFilter="false"
          v-model="selectOut"
          type="checkbox"
          tableCode="protocol_model_import"
          :data="selectList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['showUnit', 'needTestTypes']"
        >
          <!-- 显示单位 showRatio showUnit iot_tsl_data_unit -->
          <template v-slot:showUnit="scope">
            {{ getShowUnit(scope.row) }}
          </template>
          <template v-slot:needTestTypes="scope">
            {{ getNeedTestTypes(scope.row.needTestTypes) || '-' }}
          </template>
        </custom-table>
      </div>
      <div class="table-page" v-if="showTab === '1'">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button v-if="showTab === '1'" :disabled="!selectIn.length" type="primary" @click="addSelect">{{ $t('Common.com_confirm') }}</el-button>
      <el-button v-if="showTab === '2'" type="primary" @click="confirm">{{ $t('dms_step_model_import_dialog.dao_ru') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import mixins from './mixins';

export default {
  mixins: [dialogMixins, mixins],
  components: {},
  props: {
    protocolCode: String,
  },
  data() {
    return {
      tabList: [],
      showTab: '1',

      listen: '',
      verList: [],

      selectList: [], // 已选
      selectIn: [],
      selectOut: [],

      tslTypeList: [],
      formSearch: {
        tcpDataCode: '',
        search: '',
        orderBy: '',
        orderType: '',
        fromProtocolCode: '',
        fromTslVersion: '',
        toProtocolCode: '',
        tslClass: '',
        tslType: '',
        component: '',
        dataGroup: '',
        dbField: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,

      deviceType: [],
    };
  },
  mounted() {
    this.getDeviceType();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.tabList = [
      { name: this.$t('dms_step_model_import_dialog.xuan_ze_wu_mo_xing'), value: '1' },
      { name: this.$t('dms_step_model_import_dialog.yi_xuan_wu_mo_xing'), value: '2' },
    ];
  },
  methods: {
    async getDeviceType() {
      const res = await this.$getJSON(apis.ComponentCopyListProtocol, {
        // protocolCode: this.protocolCode
      });
      this.deviceType = res.data;
      this.formSearch.fromProtocolCode = this.deviceType[0].protocolCode;

      this.initDic();
    },
    initDic: function () {
      this.getDictionary('iot_tsl_class_type', () => {
        this.changeTslClass(true);
      });
    },
    changeTslClass: function (init) {
      if (init) {
        this.formSearch.tslClass = this.propertyMap.iot_tsl_class_type[0].value;
        this.tslTypeList = this.propertyMap.iot_tsl_class_type[0].children || [];
        this.onPageChange({ page: 1 });
        return;
      }
      this.propertyMap.iot_tsl_class_type.forEach((item) => {
        if (this.formSearch.tslClass === item.value) {
          this.tslTypeList = item.children || [];
        }
        this.formSearch.tslType = '';
      });
      this.onPageChange({ page: 1 });
    },
    onTableChange: function () {
      this.$refs.container.close();
      // this.$refs.containerBtn.open = false;
    },
    formatTableRow: function () {
      const list = JSON.parse(JSON.stringify(this.tableList));
      list.forEach((item) => {
        item.isExists = !!this.selectList.find(t => t.tslId === item.tslId);
      });
      this.tableList = list;
    },
    // 加入
    addSelect: function () {
      this.selectIn.forEach((item) => {
        const has = this.selectList.find(t => t.tslId === item.tslId);
        if (!has) {
          this.selectList.push(item);
        }
      });
      this.showTab = '2';
      this.formatTableRow();
    },
    // 移除
    removeSelect: function () {
      this.selectOut.forEach((item) => {
        this.selectList = this.selectList.filter(t => t.tslId !== item.tslId);
      });
      this.formatTableRow();
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.toProtocolCode = this.protocolCode;
      this.$getJSON(apis.TslImportPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    //  分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      const fromProtocolCode = this.formSearch.fromProtocolCode;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.fromProtocolCode = fromProtocolCode;
      this.onPageChange({ page: 1 });
    },
    // 确认保存
    confirm: function () {
      const tslIds = this.selectList.map(t => t.tslId);
      this.$postJSON(apis.TslImport, {
        protocolCode: this.protocolCode,
        tslIds,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.protocol-model-import-dialog {
  .el-form-item__label {
    line-height: 32px !important;
  }
}
</style>
